import { render, staticRenderFns } from "./msg.vue?vue&type=template&id=740df860&"
import script from "./msg.ts?vue&type=script&lang=ts&"
export * from "./msg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports